module.exports = __webpack_public_path__ + "img/foot_logo.919417cf.png";